var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaraxaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0428\\u0430\\u0440_2",
    "data-name": "\\u0428\\u0430\\u0440 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 312.51 312.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #15ab5a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0428\\u0430\\u0440_1-2",
    "data-name": "\\u0428\\u0430\\u0440 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 156.26,
    cy: 156.26,
    r: 156.26
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "173.6 47.49 173.6 113.55 156.27 113.55 138.95 113.55 138.95 47.49 173.6 47.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "259.12 195.64 241.8 225.65 173.6 186.28 173.6 265.02 138.95 265.02 138.95 186.28 70.75 225.65 53.39 195.64 121.58 156.27 138.95 146.23 156.27 136.23 173.6 146.27 190.93 156.27 259.12 195.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "259.12 116.91 218.44 139.92 183.78 119.92 241.8 86.86 259.12 116.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "127.56 119.92 92.87 139.92 53.39 116.91 70.75 86.86 127.56 119.92"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaraxaLogo);
export default __webpack_public_path__ + "static/media/taraxa_logo.f1839190c1970ca56395437d95203dc5.svg";
export { ForwardRef as ReactComponent };